(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["allbetter-bundle-picker"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-ab-product-bundle]').forEach((bundle) => {
    const moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    });
    const status = bundle.querySelector('[data-ab-bundle-status]');
    const setStatus = (text) => {
      if (status) status.textContent = text || '';
    };
    const redirectToCheckout = () => {
      const checkoutUrl = '/checkout';
      try {
        window.top.location.assign(checkoutUrl);
      } catch (error) {
        window.location.assign(checkoutUrl);
      }
    };
    let variants = [];
    try {
      variants = JSON.parse(bundle.querySelector('[data-ab-product-variants]')?.textContent || '[]');
    } catch (error) {
      variants = [];
    }
    const syncStickyBundleState = (isVisible) => {
      document.documentElement.classList.toggle('ab-bundle-in-view', Boolean(isVisible));
    };
    const stickyObserver = new IntersectionObserver(
      ([entry]) => syncStickyBundleState(window.matchMedia('(max-width: 749px)').matches && entry?.isIntersecting),
      { rootMargin: '-12% 0px -20% 0px', threshold: 0.08 }
    );
    stickyObserver.observe(bundle);
    window.addEventListener('resize', () => {
      const rect = bundle.getBoundingClientRect();
      syncStickyBundleState(
        window.matchMedia('(max-width: 749px)').matches &&
          rect.bottom > window.innerHeight * 0.12 &&
          rect.top < window.innerHeight * 0.8
      );
    });
    const formatMoney = (cents) => moneyFormatter.format((Number(cents) || 0) / 100);
    const getComboSavingsPercent = () => {
      const configuredPercent = Number(bundle.dataset.comboDiscountPercent || 0);
      if (configuredPercent > 0) return configuredPercent;
      const badge = bundle.querySelector('.ab-product-bundle__panel--combo .ab-combo-total em, .ab-product-bundle__panel--combo .ab-combo-banner__badge');
      const match = badge?.textContent?.match(/(\d+(?:\.\d+)?)\s*%/);
      return match ? Math.max(0, Number(match[1])) : 0;
    };

    const updateTotal = () => {
      let total = 0;
      bundle.querySelectorAll('[data-ab-combo-item]').forEach((item) => {
        const select = item.querySelector('[data-ab-variant-select]');
        const qty = item.querySelector('[data-ab-qty]');
        const priceNode = item.querySelector('[data-ab-money]');
        const selected = select?.selectedOptions?.[0];
        const price = Number(selected?.dataset.price || priceNode?.dataset.price || 0);
        const quantity = Math.max(1, Number(qty?.value || 1));
        total += price * quantity;
        if (priceNode) {
          priceNode.dataset.price = String(price);
          priceNode.textContent = formatMoney(price);
        }
      });
      const totalNode = bundle.querySelector('[data-ab-combo-total]');
      if (totalNode) totalNode.textContent = formatMoney(total);
      const savingsNode = bundle.querySelector('[data-ab-combo-savings]');
      const savingsPercent = getComboSavingsPercent();
      const savings = Math.round((total * savingsPercent) / 100);
      if (savingsNode) {
        if (savings > 0) {
          savingsNode.hidden = false;
          savingsNode.textContent = `Automatic discount saves ${formatMoney(savings)} in cart and checkout`;
        } else {
          savingsNode.hidden = true;
          savingsNode.textContent = '';
        }
      }
    };

    bundle.querySelectorAll('[data-ab-variant-select]').forEach((select) => {
      select.addEventListener('change', updateTotal);
    });

    bundle.querySelectorAll('[data-ab-qty-minus], [data-ab-qty-plus]').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('[data-ab-combo-item]');
        const input = item?.querySelector('[data-ab-qty]');
        if (!input) return;
        const next = Math.max(1, Number(input.value || 1) + (button.hasAttribute('data-ab-qty-plus') ? 1 : -1));
        input.value = String(next);
        updateTotal();
      });
    });

    bundle.querySelectorAll('[data-ab-qty]').forEach((input) => {
      input.addEventListener('input', updateTotal);
    });

    const normalizeOption = (value) => String(value || '').trim();
    const findVariantByOptions = (options) =>
      variants.find((variant) => {
        if (!variant?.available) return false;
        return options.every((optionValue, index) => normalizeOption(variant.options?.[index]) === normalizeOption(optionValue));
      }) ||
      variants.find((variant) =>
        options.every((optionValue, index) => normalizeOption(variant.options?.[index]) === normalizeOption(optionValue))
      );
    const findVariantById = (variantId) => variants.find((variant) => String(variant.id) === String(variantId));
    const getCurrentVariant = () =>
      findVariantById(bundle.dataset.currentVariantId) ||
      variants.find((variant) => variant.available) ||
      variants[0];
    const getUnitVariant = (unit) => {
      const selects = Array.from(unit.querySelectorAll('[data-ab-pack-option-select]'));
      if (!selects.length) return getCurrentVariant();
      const options = selects.map((select) => select.value);
      return findVariantByOptions(options);
    };
    const updateSinglePackCard = (packOption) => {
      if (!packOption) return;
      const units = Array.from(packOption.querySelectorAll('[data-ab-pack-unit]'));
      const totalNode = packOption.querySelector('[data-ab-pack-total]');
      const compareNode = packOption.querySelector('[data-ab-pack-compare-total]');
      const quantity = Math.max(1, Number(packOption.querySelector('input[data-mode="single"]')?.dataset.quantity || 1));
      let total = 0;
      let compareTotal = 0;
      let validUnits = 0;
      if (units.length) {
        units.forEach((unit) => {
          const variant = getUnitVariant(unit);
          unit.toggleAttribute('data-ab-pack-unit-unavailable', !variant?.available);
          if (!variant) return;
          unit.dataset.variantId = String(variant.id);
          total += Number(variant.price || 0);
          compareTotal += Number(variant.compare_at_price || 0);
          validUnits += 1;
        });
      } else {
        const variant = getCurrentVariant();
        total = Number(variant?.price || 0) * quantity;
        compareTotal = Number(variant?.compare_at_price || 0) * quantity;
        validUnits = quantity;
      }
      if (validUnits && totalNode) totalNode.textContent = formatMoney(total);
      if (compareNode) {
        if (compareTotal > total) {
          compareNode.hidden = false;
          compareNode.textContent = formatMoney(compareTotal);
        } else {
          compareNode.hidden = true;
          compareNode.textContent = '';
        }
      }
    };
    const updateAllSinglePackCards = () => {
      bundle.querySelectorAll('[data-ab-pack-option]').forEach(updateSinglePackCard);
    };
    const syncPackRowsToVariant = (variant) => {
      if (!variant?.options) return;
      bundle.querySelectorAll('[data-ab-pack-unit]').forEach((unit) => {
        unit.querySelectorAll('[data-ab-pack-option-select]').forEach((select) => {
          const optionIndex = Number(select.dataset.optionIndex || 0);
          const optionValue = variant.options[optionIndex];
          if (optionValue && Array.from(select.options).some((option) => option.value === optionValue)) {
            select.value = optionValue;
          }
        });
      });
      updateAllSinglePackCards();
    };
    const getSinglePackItems = (activePanel) => {
      const checked = activePanel?.querySelector('input[data-mode="single"]:checked') || bundle.querySelector('input[data-mode="single"]:checked');
      const packOption = checked?.closest('[data-ab-pack-option]');
      const units = Array.from(packOption?.querySelectorAll('[data-ab-pack-unit]') || []);
      if (!checked) return [];
      if (!units.length) {
        return [
          {
            id: Number(bundle.dataset.currentVariantId),
            quantity: Math.max(1, Number(checked.dataset.quantity || 1)),
            properties: { _Bundle: checked.dataset.title || 'Pack and save' },
          },
        ];
      }
      const groupedItems = new Map();
      units.forEach((unit) => {
        const variant = getUnitVariant(unit);
        unit.toggleAttribute('data-ab-pack-unit-unavailable', !variant?.available);
        if (!variant?.available) return;
        const itemKey = String(variant.id);
        const existingItem = groupedItems.get(itemKey);
        if (existingItem) {
          existingItem.quantity += 1;
        } else {
          groupedItems.set(itemKey, {
            id: Number(variant.id),
            quantity: 1,
            properties: { _Bundle: checked.dataset.title || 'Pack and save' },
          });
        }
      });
      return Array.from(groupedItems.values());
    };
    const syncSinglePackQuantity = () => {
      const checked = bundle.querySelector('input[data-mode="single"]:checked');
      if (!checked) return;

      const quantity = Math.max(1, Number(checked.dataset.quantity || 1));
      const checkedPackOption = checked.closest('[data-ab-pack-option]');
      const firstUnitVariant = getUnitVariant(checkedPackOption?.querySelector('[data-ab-pack-unit]'));
      const productDetails = bundle.closest('[data-product-id], product-information, .product-information, section') || document;
      const nativeQuantityInput =
        productDetails.querySelector('product-form-component input[name="quantity"]') ||
        document.querySelector('product-form-component input[name="quantity"]');
      const nativeVariantInput =
        productDetails.querySelector('product-form-component input[name="id"]') ||
        document.querySelector('product-form-component input[name="id"]');
      const hint = bundle.querySelector('[data-ab-single-pack-hint]');

      if (nativeQuantityInput) {
        nativeQuantityInput.value = String(quantity);
        nativeQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        nativeQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (nativeVariantInput && firstUnitVariant?.id) {
        nativeVariantInput.value = String(firstUnitVariant.id);
        nativeVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (hint) {
        const title = checked.dataset.title || 'Pack';
        hint.textContent = `${title} selected. Choose each item's options, then use the buttons below.`;
      }
      updateSinglePackCard(checkedPackOption);
    };

    bundle.querySelectorAll('input[data-mode="single"]').forEach((radio) => {
      radio.addEventListener('change', syncSinglePackQuantity);
    });

    bundle.querySelectorAll('[data-ab-pack-option-select]').forEach((select) => {
      select.addEventListener('change', () => {
        updateSinglePackCard(select.closest('[data-ab-pack-option]'));
        syncSinglePackQuantity();
      });
    });

    document.addEventListener('variant:update', (event) => {
      const productId = event.detail?.data?.productId;
      const variantId = event.detail?.resource?.id;
      if (productId && String(productId) !== String(bundle.dataset.productId)) return;
      if (!variantId) return;
      bundle.dataset.currentVariantId = String(variantId);
      syncPackRowsToVariant(event.detail?.resource || findVariantById(variantId));
      const currentSelect = bundle.querySelector('[data-ab-combo-item][data-required="true"] [data-ab-variant-select]');
      if (currentSelect) {
        currentSelect.value = String(variantId);
        updateTotal();
      }
    });

    let isAddingBundle = false;

    const getButtonLabelElement = (button) =>
      button.querySelector('.add-to-cart-text__content span span') || button.querySelector('.button-text') || button;

    const setBundleButtonsBusy = (busy, triggerButton, busyLabel = 'ADDING...') => {
      const buttons = Array.from(bundle.querySelectorAll('[data-ab-bundle-checkout]'));
      if (triggerButton instanceof HTMLButtonElement && !buttons.includes(triggerButton)) {
        buttons.push(triggerButton);
      }
      buttons.forEach((button) => {
        const labelElement = getButtonLabelElement(button);
        if (!button.dataset.abOriginalText) {
          button.dataset.abOriginalText = labelElement.textContent || '';
        }
        button.disabled = busy;
        button.toggleAttribute('aria-busy', busy);
        labelElement.textContent = busy ? busyLabel : button.dataset.abOriginalText;
      });
    };

    const normalizeComboCheckoutButtons = () => {
      bundle
        .querySelectorAll('[data-ab-bundle-panel="combo"] [data-ab-bundle-checkout]')
        .forEach((button) => {
          const labelElement = getButtonLabelElement(button);
          labelElement.textContent = 'BUY NOW';
          button.dataset.abOriginalText = 'BUY NOW';
          button.setAttribute('aria-label', 'BUY NOW');
        });
    };

    const addItems = async (activePanel, goToCheckout, triggerButton) => {
      if (isAddingBundle) return;

      const items = [];

      if (activePanel?.dataset.abBundlePanel === 'combo') {
        bundle.querySelectorAll('[data-ab-combo-item]').forEach((item) => {
          const select = item.querySelector('[data-ab-variant-select]');
          const qty = item.querySelector('[data-ab-qty]');
          if (!select?.value) return;
          items.push({
            id: Number(select.value),
            quantity: Math.max(1, Number(qty?.value || 1)),
            properties: { _Bundle: 'Multi-product combo' },
          });
        });
      } else {
        items.push(...getSinglePackItems(activePanel));
      }

      if (!items.length || items.some((item) => !item.id)) {
        setStatus('Please choose available options first.');
        return;
      }

      isAddingBundle = true;
      setBundleButtonsBusy(true, triggerButton, goToCheckout ? 'REDIRECTING...' : 'ADDING...');
      setStatus(goToCheckout ? 'Redirecting to checkout...' : 'Adding bundle...');
      let isRedirecting = false;

      try {
        const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
        const body = { items };

        const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const payload = await response.json();
        if (!response.ok || payload.status) {
          setStatus(payload.description || payload.message || 'Unable to add bundle.');
          return;
        }

        if (goToCheckout) {
          isRedirecting = true;
          redirectToCheckout();
          return;
        }

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: payload,
              data: {
                source: 'product-form-component',
                itemCount: totalQuantity,
                sections: payload.sections,
              },
            },
          })
        );
        setStatus('Bundle added to cart.');
      } catch (error) {
        console.error(error);
        setStatus('Unable to add bundle.');
      } finally {
        if (!isRedirecting) {
          isAddingBundle = false;
          setBundleButtonsBusy(false, triggerButton);
        }
      }
    };

    const productDetails = bundle.closest('[data-product-id], product-information, .product-information, section') || document;
    const productForm = productDetails.querySelector('product-form-component form') || document.querySelector('product-form-component form');
    if (productForm) {
      productForm.addEventListener(
        'click',
        (event) => {
          const submitButton = event.target?.closest?.('button[type="submit"][name="add"]');
          if (!submitButton || !productForm.contains(submitButton)) return;

          const checked = bundle.querySelector('input[data-mode="single"]:checked');
          if (!checked) return;
          const items = getSinglePackItems(bundle.querySelector('[data-ab-bundle-panel="single"]'));
          if (!items.length) {
            setStatus('Please choose available options first.');
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();
          addItems(
            bundle.querySelector('[data-ab-bundle-panel="single"]'),
            submitButton.dataset.directCheckout === 'true',
            submitButton
          );
        },
        true
      );

      productForm.addEventListener(
        'submit',
        (event) => {
          const submitButton = event.submitter?.closest?.('button[type="submit"][name="add"]');
          if (!submitButton || !productForm.contains(submitButton)) return;

          const checked = bundle.querySelector('input[data-mode="single"]:checked');
          if (!checked) return;
          const items = getSinglePackItems(bundle.querySelector('[data-ab-bundle-panel="single"]'));
          if (!items.length) {
            setStatus('Please choose available options first.');
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          event.preventDefault();
          event.stopImmediatePropagation();
          addItems(
            bundle.querySelector('[data-ab-bundle-panel="single"]'),
            event.submitter?.dataset.directCheckout === 'true',
            event.submitter
          );
        },
        true
      );
    }
    const moveSingleBuyButtons = () => {
      const slot = bundle.querySelector('[data-ab-single-buy-buttons-slot]');
      if (!slot) return;
      const productDetails = bundle.closest('[data-product-id], product-information, .product-information, section') || document;
      const buyButtonsBlock =
        productDetails.querySelector('product-form-component')?.closest('.buy-buttons-block') ||
        document.querySelector('product-form-component')?.closest('.buy-buttons-block');
      if (!buyButtonsBlock || slot.contains(buyButtonsBlock)) return;
      slot.appendChild(buyButtonsBlock);
      slot.querySelectorAll('[data-direct-checkout="true"]').forEach((button) => {
        button.closest('add-to-cart-component')?.remove();
      });
    };

    bundle.querySelectorAll('[data-ab-bundle-checkout]').forEach((button) => {
      button.addEventListener('click', () => {
        const panel = button.closest('[data-ab-bundle-panel]');
        addItems(panel, panel?.dataset.abBundlePanel === 'combo', button);
      });
    });
    normalizeComboCheckoutButtons();
    moveSingleBuyButtons();
    syncPackRowsToVariant(getCurrentVariant());
    syncSinglePackQuantity();
    updateTotal();
  });
  } catch(e) { console.error(e); }
})();

})();
